import React, { useState } from "react";
import { Link } from "react-router-dom";
import BipsyPayLogo from "../../img/BipsyPay/Bipsy.png"
import StatementImage from "../../img/BipsyPay/Statement.png"
import LeftImage from "../../img/BipsyPay/LeftImage.png"
import RightImage from "../../img/BipsyPay/RightImage.png"
import Myth from "../../img/BipsyPay/Myth.jpg"
import Corrot from "../../img/carrot.svg"
import BipsyCarrot from "../../img/BipsyPay/BipsyCarrot.png"
import GreyBipsy from "../../img/BipsyPay/GreyBipsypay.png"
import InfoModal from "../../components/modals/LargeModal";
import { FaSquareFacebook } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";




export default function Landing({ nextStep }) {
    return (
        <div>
            <div className="flex flex-wrap bg-white rounded-lg shadow w-9/12 w-fit justify-center my-12 mx-12 md:my-12 md:mx-24">
                {/* Top White Say Goodbye */}
                <div className="2xl:w-4/6 xl:w-4/6 lg:w-4/6 md:w-4/6 sm:w-4/6 w-4/6 mt-12">
                    <img src={BipsyPayLogo} />
                </div>
                <div className="flex flex-wrap mx-12">
                    <div className="flex w-full text-center justify-center text-4xl font-bold text-black m-auto mb-4 mt-8 px-12 md:px-6">

                    </div>
                    <div className="lg:w-2/6">
                        <img className="" src={StatementImage} />
                    </div>
                    <div className="md:w-1/2 m-auto text-center justify-center text-4xl font-bold text-black">
                        <h1 className="xl:text-5xl lg:text-4xl md:text-4xl text-2xl font-bold text-black">Say Goodbye to</h1>
                        <h1 className="xl:text-5xl lg:text-4xl md:text-4xl text-2xl font-bold text-black">Credit Card</h1>
                        <h1 className="xl:text-5xl lg:text-4xl md:text-4xl text-2xl font-bold text-black">Transaction Fees</h1>
                        <h1 className="xl:text-5xl lg:text-4xl md:text-4xl text-2xl font-bold text-black">FOREVER</h1>
                        <div className="flex flex-wrap -mx-3 mb-4">
                            <div className="w-full md:w-1/2 px-3 md:mb-0">
                                <button onClick={nextStep} className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Get Started</button>
                            </div>
                            <div className="w-full md:w-1/2 px-3">
                                <Link to="/info" > <button type="submit" className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Tell Me More</button></Link>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Purple Background */}
                <div className="flex flex-wrap bg-main-purple text-white pb-12">
                    <div className="flex w-full text-center justify-center text-4xl font-bold text-white m-auto mb-6 mt-12 px-12 md:px-6">
                        <div>Its Been Around For Years... Now It's Your Turn</div>
                    </div>

                    {/* Cart Purple */}
                    <div className="lg:w-2/6">
                        <img className="" src={LeftImage} />
                    </div>
                    <div className="lg:w-1/2 md:m-auto m-auto text-center px-12 md:px-6 mb-12">
                        <div className="xl:text-4xl lg:text-3xl md:text-2xl text-xl">Gas stations have used cash discounts on the price of gas for many years. If you pay with cash, it costs a little less per gallon. If you pay with a credit card, it's listed on the sign and on the pump.</div>
                    </div>
                    {/* Payment Purple */}
                    <div className="flex w-full text-center justify-center text-4xl font-bold text-white m-auto mb-6 mt-12 px-12 md:px-6">
                        <div>Bipsypay Offers</div>
                    </div>
                    <div className="lg:w-2/6">

                        <img className="" src={RightImage} />
                    </div>
                    <div className="flex lg:w-1/2 md:m-auto m-auto mx-auto justify-center px-12 md:px-6">
                        <div className="">
                            <ul className="list-disc">
                                <li className="xl:text-4xl lg:text-3xl md:text-2xl text-xl">NO credit card processing fees</li>
                                <li className="xl:text-4xl lg:text-3xl md:text-2xl text-xl">NO service fees</li>
                                <li className="xl:text-4xl lg:text-3xl md:text-2xl text-xl">NO hardware costs</li>
                                <li className="xl:text-4xl lg:text-3xl md:text-2xl text-xl">Free support, signage and training</li>
                            </ul>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                <div className="w-full md:w-1/2 px-3 pt-6 md:mb-0">
                                    <button onClick={nextStep} className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Get Started</button>
                                </div>
                                <div className="w-full md:w-1/2 pt-3 md:pt-6 px-3">
                                    <Link to="/info" > <button type="submit" className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Tell Me More</button></Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                {/* Myths */}
                <div className="flex flex-wrap bg-white text-black mx-12 pb-12">
                    {/* Titles */}
                    <div className="flex w-full text-center justify-center m-auto mb-4 mt-8 text-4xl font-bold">
                        <div>Our Clients Save an Average of $35k Per Year!</div>
                    </div>
                    <div className="flex w-full text-center justify-center m-auto mb-4 mt-8 text-3xl">
                        <div>Cash discounting programs are widely preferred over fee recovery methods because they typically provide a more favorable customer experience</div>
                    </div>
                    {/* Myth Left Image */}
                    <div className="md:w-1/2 m-auto">
                        <img className="" src={Myth} />
                    </div>
                    {/* Myth Right List */}
                    <div className="xl:w-1/2 m-auto justify-center md:text-4xl text-2xl text-black">
                        <div className="ml-3 font-bold md:text-4xl text-2xl">4 Popular Myths</div>
                        <ol className="list-decimal ml-12">
                            <li>
                                Customers Will Complain
                                <h4 className="text-base cursor-pointer inline-flex items-center ml-2 text-black font-light leading-tight tracking-tight">
                                    <InfoModal
                                        title="Reality"
                                        desc="This is by far the most common objection we hear, and it certainly stands to reason 
                                        that customers will be put off by being asked to pay a few pennies on the dollar extra for using
                                        their credit card. In practice, this assumption simply doesn't hold water. First, for many
                                        retailers, especially small-ticket shops, the convenience fee is usually very insignificant, less
                                        than $1.00 on a $25 total sale. Second, our clients report fewer than 1 in 100 customers 
                                        will ever voice an objection, and, when they do, they have the option to pay in cash to avoid the
                                        fee. Most merchants quickly realisze that the annual savings in credit card processing fees
                                        (typically thousands of dollars per month) far outweighs the potential of losing one or two
                                        customers. Finally, the practice of surcharging (see below) or offering a cash discount is rapidly
                                        gaining popularity and will very likely become common practice among most merchants."
                                    >
                                    </InfoModal>
                                </h4>
                            </li>
                            <li>
                                I Can Just Add the Fee
                                <h4 className="text-base cursor-pointer inline-flex items-center ml-2 text-black font-light leading-tight tracking-tight">
                                    <InfoModal
                                        title="Reality"
                                        desc="The practice of surcharging (vs cash discounting) is growing in popularity, typically by
                                        merchants who are less savvy about the legal and practical requirements of doing it. In
                                        short, yes, you can add a surcharge or convenience fee to all card transactions, however you
                                        will likely run afoul of card processor regulations if not done correctly. There are MANY
                                        requirements imposed by card brands, the violation of which could result in heavy fines and/or
                                        suspension of processing privileges. Furthermore, adding a surcharge simply increases your
                                        total cost without fully offsetting them the way cash discounting can. Finally, offering your
                                        customers an up-front discount by using cash has proven to be a much more customer-friendly
                                        approach to recover your processing fees."
                                    >
                                    </InfoModal>
                                </h4>
                            </li>
                            <li>
                                I Won't Really Save Money
                                <h4 className="text-base cursor-pointer inline-flex items-center ml-2 text-black font-light leading-tight tracking-tight">
                                    <InfoModal
                                        title="Reality"
                                        desc="We tell our clients: “Look at last month’s merchant statement you received from your
                                        credit card provider. Add up all the statement fees, exchange fees, service charges and
                                        equipment costs. Now add that number back to your bottom line - every month - and tell us if
                                        you think it’s worth it.” For the average small retailer, credit card processing fees can be as high
                                        as $5k or more per month. Many retailers, when they realize how much they are losing every
                                        month to credit card processing, simply raise their prices to offset their costs. This practice
                                        offends all customers, especially those loyal customers who pay in cash who are now
                                        subsidizing customers who pay by credit."
                                        desc2="Implementing with an experienced, reputable cash discounting solution like Bipsypay is a much
                                        easier proposition than you might realize. Bipsypay provides you with all the pre-configured
                                        hardware, required signage and helpful training to get you up and running in just a few days –
                                        so you can start adding to your bottom line in no time."
                                    >
                                    </InfoModal>
                                </h4>
                            </li>
                            <li>Sounds Too Good to Be True
                                <h4 className="text-base cursor-pointer inline-flex items-center ml-2 text-black font-light leading-tight tracking-tight">
                                    <InfoModal
                                        title="Reality"
                                        desc="There is no catch. With Bipsypay, There is no charge for base-level hardware, no charge
                                        for support, signage and training, and no charge for credit card processing fees or service fees.
                                        Bipsypay will use the cash discounting fees you collect to pay 100% of your merchant fees for
                                        you. What you record as sales revenue is exactly what will be deposited into your bank account.
                                        Best of all, there are no contracts to sign – you are free to cancel at any time."
                                    >
                                    </InfoModal>
                                </h4>
                            </li>
                        </ol>
                        <div className="flex flex-wrap -mx-3 mb-4">
                            <div className="w-full md:w-3/4 px-3 py-1.5 md:mb-0">
                                <button onClick={nextStep} className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Get Started</button>
                            </div>
                            <div className="w-full md:w-3/4 pt-1.5 px-3">
                                <Link to="/info" > <button type="submit" className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Tell Me More</button></Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Grey Footer */}
                <div className="flex flex-wrap bg-promo-grey text-white w-full">
                    {/* Left Purple */}
                    <footer className="w-full bg-promo-grey rounded-lg dark:bg-promo-grey m-4">
                        <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                            <div className="sm:flex sm:items-center sm:justify-between">
                                <a href="https://www.bipsypay.com" target="blank" className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
                                    <img src={GreyBipsy} className="h-8" alt="Flowbite Logo" />
                                </a>
                                <div className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0 dark:text-white">
                                    <h4>Oceanside, CA 92057</h4>
                                </div>
                            </div>
                            <div className="sm:flex sm:items-center sm:justify-between">
                                <div></div>
                                <div className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0 dark:text-white">
                                    <h4>833-MYCASH7 (833.692.2747)</h4>
                                </div>
                            </div>
                            <div className="sm:flex sm:items-center sm:justify-between">
                                <div></div>
                                <div className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0 dark:text-white">
                                    <h4>connect@bipsypay.com</h4>
                                </div>
                            </div>
                            <div className="sm:flex sm:items-center sm:justify-between">
                                <div></div>
                                <div className="flex flex-row">
                                    <a href="https://www.linkedin.com/company/bipsypay/" target="blank"><FaLinkedin /></a>
                                    <div>&nbsp;&nbsp;</div>
                                    <a href="https://www.facebook.com/people/Bipsypay/100083540051999/" target="blank"><FaSquareFacebook /></a>
                                </div>
                                <div></div>
                            </div>
                            <div className="sm:text-center"></div>
                        </div>
                    </footer>
                </div>

            </div>
        </div>




    );
}